import { render, staticRenderFns } from "./PoolMatch.vue?vue&type=template&id=dec06e7e&"
import script from "./PoolMatch.vue?vue&type=script&lang=js&"
export * from "./PoolMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports